/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var Bank131ApiDomainBank131ConstantsBank131ApiType;
(function (Bank131ApiDomainBank131ConstantsBank131ApiType) {
    Bank131ApiDomainBank131ConstantsBank131ApiType[Bank131ApiDomainBank131ConstantsBank131ApiType["Bank131"] = 0] = "Bank131";
    Bank131ApiDomainBank131ConstantsBank131ApiType[Bank131ApiDomainBank131ConstantsBank131ApiType["SmartGLocal"] = 1] = "SmartGLocal";
    Bank131ApiDomainBank131ConstantsBank131ApiType[Bank131ApiDomainBank131ConstantsBank131ApiType["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(Bank131ApiDomainBank131ConstantsBank131ApiType || (Bank131ApiDomainBank131ConstantsBank131ApiType = {}));
export function instanceOfBank131ApiDomainBank131ConstantsBank131ApiType(value) {
    for (const key in Bank131ApiDomainBank131ConstantsBank131ApiType) {
        if (Object.prototype.hasOwnProperty.call(Bank131ApiDomainBank131ConstantsBank131ApiType, key)) {
            if (Bank131ApiDomainBank131ConstantsBank131ApiType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function Bank131ApiDomainBank131ConstantsBank131ApiTypeFromJSON(json) {
    return Bank131ApiDomainBank131ConstantsBank131ApiTypeFromJSONTyped(json, false);
}
export function Bank131ApiDomainBank131ConstantsBank131ApiTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function Bank131ApiDomainBank131ConstantsBank131ApiTypeToJSON(value) {
    return value;
}
export function Bank131ApiDomainBank131ConstantsBank131ApiTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=Bank131ApiDomainBank131ConstantsBank131ApiType.js.map